import { Button, Popover } from '@patternfly/react-core'
import { Thead, Tr, Th } from '@patternfly/react-table'
import * as React from 'react'

import type { PatientMedicationRecord } from '@app/domain/patient-medication-history/patient-medication-history.interface'
import { ActionLink } from '@app/utils/styles/action-link'

import { EditRecordPopOverContent } from './edit-record-popover'

interface Props {
  addMedicationRecord: () => void
  editRecordDate: (
    activeDate: string,
    medicationRecord: PatientMedicationRecord,
  ) => void
  deleteRecord: (medicationRecordId: string) => void
  medicationRecord: PatientMedicationRecord[]
  medicationsExist: boolean
}

export const MedicationListHeader = ({
  addMedicationRecord,
  editRecordDate,
  deleteRecord,
  medicationRecord,
  medicationsExist,
}: Props) => {
  return (
    <Thead>
      <Tr>
        {medicationsExist ? <Th isStickyColumn width={10} /> : null}
        {medicationRecord.map((medication) => (
          <Th
            width={10}
            modifier="nowrap"
            key={medication.id}
            style={{ textAlign: 'center', verticalAlign: 'middle' }}
          >
            <Popover
              aria-label="Edit Record Date"
              showClose={false}
              hasAutoWidth
              bodyContent={() => (
                <EditRecordPopOverContent
                  key={medication.id}
                  activeDate={medication.activeDate}
                  editRecordDate={editRecordDate}
                  deleteRecord={deleteRecord}
                  medicationRecord={medication}
                />
              )}
              withFocusTrap={false}
            >
              <ActionLink className="Medication">
                {medication.activeDate}
              </ActionLink>
            </Popover>
          </Th>
        ))}
        <Th
          width={10}
          modifier="nowrap"
          style={{ textAlign: 'center', verticalAlign: 'middle' }}
        >
          <Button variant="secondary" onClick={addMedicationRecord}>
            Add Record
          </Button>
        </Th>
      </Tr>
    </Thead>
  )
}
